const challengingordermanagement = r => require.ensure([], () => r(require(
		'../../views/warehousemanagement/challengingordermanagement/challengingordermanagement.vue')),
	'challengingordermanagement')
const outboundreportmanagement = r => require.ensure([], () => r(require(
		'../../views/warehousemanagement/outboundreportmanagement/outboundreportmanagement.vue')),
	'outboundreportmanagement')
const warehousingreportmanagement = r => require.ensure([], () => r(require(
		'../../views/warehousemanagement/warehousingreportmanagement/warehousingreportmanagement.vue')),
	'warehousingreportmanagement')

const otheroutreportmanagement = r => require.ensure([], () => r(require(
		'../../views/warehousemanagement/otheroutreportmanagement/otheroutreportmanagement.vue')),
	'otheroutreportmanagement')

const consignordermanagement = r => require.ensure([], () => r(require(
		'../../views/warehousemanagement/consignordermanagement/consignordermanagement.vue')),
	'consignordermanagement')

const customerCheckVouch = r => require.ensure([], () => r(require(
		'../../views/warehousemanagement/customerCheckVouch/customerCheckVouch.vue')),
	'customerCheckVouch')

const stockByCustomer = r => require.ensure([], () => r(require(
		'../../views/warehousemanagement/stockByCustomer/stockByCustomer.vue')),
	'stockByCustomer')

const uniqueStockByCustomer = r => require.ensure([], () => r(require(
                '../../views/warehousemanagement/uniqueStockByCustomer/uniqueStockByCustomer.vue')),
        'uniqueStockByCustomer')

const ConsignStockByCustomer = r => require.ensure([], () => r(require(
                '../../views/warehousemanagement/ConsignStockByCustomer/ConsignStockByCustomer.vue')),
        'ConsignStockByCustomer')

const warehousemanagementChildrenRouter = [{
		path: '/WMS/TransVouch',
		name: 'challengingordermanagement',
		component: challengingordermanagement,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/WMS/Despatch',
		name: 'outboundreportmanagement',
		component: outboundreportmanagement,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/WMS/ASN',
		name: 'warehousingreportmanagement',
		component: warehousingreportmanagement,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/WMS/OtherOut',
		name: 'otheroutreportmanagement',
		component: otheroutreportmanagement,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/WMS/ConsignOrder',
		name: 'consignordermanagement',
		component: consignordermanagement,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/WMS/CustomerCheckVouch',
		name: 'customerCheckVouch',
		component: customerCheckVouch,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/WMS/StockByCustomer',
		name: 'stockByCustomer',
		component: stockByCustomer,
		meta: {
			typePage: 2
		}
	}, {
		path: '/WMS/UniqueStockByCustomer',
		name: 'uniqueStockByCustomer',
		component: uniqueStockByCustomer,
		meta: {
			typePage: 2
		}
	}, {
		path: '/WMS/ConsignStockByCustomer',
		name: 'ConsignStockByCustomer',
		component: ConsignStockByCustomer,
		meta: {
			typePage: 2
		}
	}
];
export default warehousemanagementChildrenRouter